export default "__VITE_ASSET__BK1HV$jC__"